module.exports = __webpack_public_path__ + "img/CF.275f7c7b.svg";